import { IDR } from '@/libs/currency'

export const columnConfig = [
  {
    key: 'partner_name',
    label: 'Partner',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '320px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'telephone',
    label: 'Kontak',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'used_card_count',
    label: 'Kuota Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'account_control',
    label: 'Kontrol Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'total_spending',
    label: 'Spending Bulanan',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'last_transaction',
    label: 'Transaksi Terakhir',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'more',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
]

export const columnRiskReview = [
  {
    key: 'index',
    label: 'No',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '80px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'name',
    label: 'Nama',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '220px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'total_spending',
    label: 'Total Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => IDR(value),
  },
  {
    key: 'monthly_spending',
    label: 'Spending Bulan Ini',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => IDR(value),
  },
  {
    key: 'total_decline_transaction',
    label: 'Jumlah Decline Transaksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '220px',
      textAlign: 'left',
    },
    tdClass: 'text-black text-center',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'active_cards',
    label: 'Kartu Aktif',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'text-black text-center',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => `${value?.active}/${value?.total} (${value?.percentage}%)`,
  },
  {
    key: 'overdrawn_cards',
    label: 'Kartu Minus',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'center',
    },
    tdClass: 'text-black text-center',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'action',
    label: 'Action',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
]

export const status = []
